import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import CondicionesGeneralesMexico from './CondicionesGeneralesMexico';
import TextConditionsArgentina from './TextConditionsArgentina';
import {
  selectPaisId,
  selectHeader,
  selectTemplateData,
  selectPrincipalOffice,
} from 'legacyfrontend/redux/selectors/application-selectors';
import { ROUTE_KEYS } from 'legacyfrontend/constants';
import { Seo } from 'core/components/seo';
import { useAppName } from 'legacyfrontend/hooks/useSafeState';

export default function GeneralConditions() {
  const { t } = useTranslation(['layout']);
  const paisId = useSelector(selectPaisId);
  const header = useSelector(selectHeader);
  const templateData = useSelector(selectTemplateData);
  const principalOffice = useSelector(selectPrincipalOffice);
  const footer = templateData?.footer;
  const appName = useAppName();

  if (paisId === 2 || paisId === 3) {
    return <Redirect to={ROUTE_KEYS.PRIVACY_POLICY} />;
  }

  const emailContacto = header?.emailContacto || principalOffice?.email;
  const company = header?.empresa;
  const razonSocial = footer?.razonSocial;

  if (paisId === 1) {
    return (
      <>
        <Seo
          title={`${t('footer.generalConditions')} | ${appName}`}
          description={`Condiciones generales de contratación de ${appName}. Información importante para tu viaje.`}
        />
        <div className='pt-7 pb-10 py-5 container'>
        <div className='px-12 py-12 bg-white rounded-md'>
          <h1 className='text-2xl text-black font-bold text-center mb-8'>
            {t('footer.generalConditions')}
          </h1>
          <div className='text-sm text-gray-400 font-bold mb-6'>
            <p className='mb-1'>
              {`Sr. Pasajero, atento su requerimiento de intermediación en la contratación de servicios turísticos , esta Agencia cumple en informarle las condiciones generales de contratación. Es de vital importancia para su viaje, que Ud. lea las mismas. Si está de acuerdo le solicitamos nos envíe  su aceptación al siguiente mail: ${emailContacto}.`}
            </p>
            <p className='mb-6'>
              {`Esta agencia sólo dará tramite a su reserva, previa lectura y conformidad de las mismas. Atte: ${company} Agencia`}
            </p>
          </div>
          <div className='text-sm text-gray-400 py-12'>
            <TextConditionsArgentina />
          </div>
        </div>
      </div>
      </>
    );
  }

  if (paisId === 4) {
    return (
      <>
        <Seo
          title={`${t('footer.generalConditions')} | ${appName}`}
          description={`Condiciones generales de contratación de ${appName}. Información importante para tu viaje.`}
        />
        <div className='pt-7 pb-10 py-5 container'>
        <div className='px-12 py-12 bg-white rounded-md'>
          <h1 className='text-2xl text-black font-bold text-center mb-8'>
            {t('footer.generalConditions')}
          </h1>
          <div className='text-sm text-gray-400 py-12'>
            <CondicionesGeneralesMexico
              emailContacto={emailContacto}
              company={company}
              razonSocial={razonSocial}
            />
          </div>
        </div>
      </div>
      </>
    );
  }

  return null;
}
